import { combineReducers } from 'redux';
import usersActivityFilters from 'store/reducers/users-activity/get-users-activity-filters';
import getUsersActivity from 'store/reducers/users-activity/get-users-activity';
import usersActivityTableFilters from 'store/reducers/users-activity/get-users-activity-table-filters';

export default combineReducers({
  usersActivityFilters,
  getUsersActivity,
  usersActivityTableFilters,
});